import { Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

type VariationSummaryProps = {
  rules: number;
  nullRules: number;
  contextTargets: number;
  targets: number;
  isFallthrough?: boolean;
  isOff?: boolean;
  rollout?: number;
  bucketBy?: string;
};

export class VariationSummary extends Record<VariationSummaryProps>({
  isFallthrough: false,
  isOff: false,
  nullRules: 0,
  rollout: 0,
  rules: 0,
  targets: 0,
  contextTargets: 0,
}) {}

export function createVariationSummary(props?: CreateFunctionInput<VariationSummary>) {
  return props instanceof VariationSummary ? props : new VariationSummary(props);
}
